
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/em-direto/[slug]",
      function () {
        return require("private-next-pages/em-direto/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/em-direto/[slug]"])
      });
    }
  